import { lazy } from "react";

export const KernalLogin =  lazy(()=> import('./KernalLogin'))
export const RootLogin =  lazy(()=> import('./RootLogin'))
export const Role = lazy(()=> import('./Role'))
export const Organization = lazy(()=> import('./Organization'))
export const User = lazy(()=> import('./User'))
export const Application = lazy(()=> import('./Application'))
export const Profile = lazy(()=> import('./Profile'))

